import { createMarker, changeMarkerPopupToSelectedChannelIcon } from '../../LeafletMap/CreateMarker';
import { channelMarkerElement } from './MarkersAndIcons';

// Add all channel markers to the map
export const addChannelMarkers = (channelList, options = {}) => {
  const {
    selectedChannelRef,
    selectedMarkerRef,
    allowSelectingChannel,
    mapInstanceRef,
  } = options;

  channelList.forEach(channel => {
    const markerElement = channelMarkerElement(channel, allowSelectingChannel);
    if (doesChannelHaveCoordinates(channel)) {
      if (channelAlreadySelected(channel, selectedChannelRef)) {
        
        // blue color marker for selected channel
        const marker = createMarker({ channel, map: mapInstanceRef.current, markerColor: "blue", markerElement, options });
        // Ensure selected marker is on top
        marker.setZIndexOffset(1000); 
        
        // If channel is selected already from list view or elsewhere, set the selected marker to the current marker
        selectedMarkerRef.current = marker;
        options.marker = marker;
        options.channel = channel;
        changeMarkerPopupToSelectedChannelIcon(options);
        marker.openPopup();
      } else {
        // Create default marker (black)
        createMarker({ channel, map: mapInstanceRef.current, markerElement, options });
      }
    }
  });
};

export const channelAlreadySelected = (channel, selectedChannelRef) => {
  return selectedChannelRef?.current?.id === channel.id;
}

export const doesChannelHaveCoordinates = (channel) => {
  return channel.coordinates && channel.coordinates[0] !== null;
}

export const openClosestMarkerToUser = (map, channelList, userCoordinates, options = {}) => {
  let closestChannel = null;
  let shortestDistance = Infinity;
  const { allowSelectingChannel } = options;

  channelList.forEach(channel => {
    if (doesChannelHaveCoordinates(channel)) {
      const distance = map.distance(userCoordinates, channel.coordinates);
      
      if (distance < shortestDistance) {
        shortestDistance = distance;
        closestChannel = channel;
      }
    }
  });

  if (closestChannel) {
    map.setView(closestChannel.coordinates, 12);
    const markerElement = channelMarkerElement(closestChannel, allowSelectingChannel);
    const marker = createMarker({ channel: closestChannel, map, markerColor: "black", markerElement, options });
    marker.openPopup();
  }
};
